export const recurring_invoiceVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "product_description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "product_category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "product_sub_category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Account",
      "value": "account_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false,       "display": "Invoice QTY",
      "value": "invoice_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    // {
    //   "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Free Qty",
    //   "value": "free_qty",
    //   "is_text": false, "is_number": true,
    //   "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    // },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Conversion Unit Price",
      "value": "conversion_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "FC Invoice Unit Price",
      "value": "conversion_invoice_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Unit Price",
      "value": "invoice_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price",
      "value": "invoice_total_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "Invoice CGST",
      "value": "invoice_cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "Invoice SGST",
      "value": "invoice_sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "Invoice IGST",
      "value": "invoice_igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "Invoice UGST",
      "value": "invoice_ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "Invoice CESS",
      "value": "invoice_cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Invoice Other Tax",
      "value": "invoice_other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price GST",
      "value": "invoice_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Price",
      "value": "invoice_grand_total",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "grnreport", "name": 'GRN Details', "Desscription": 'GRN', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Particulars",
    "value": "title",
    "is_text": true, "is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice",
    "value": "invoice_amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice",
    "value": "is_ddc_total_invoice_amount",
    "is_text": true, "is_number": true,
    "is_ddc": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
  }
  ],
  "extraGrandColumnList":[],
  'extra_data_list':{'title':'','records':[]}
}
export const invoiceVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice No",
      "value": "invoice_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor Invoice Date",
      "value": "vendor_invoice_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Due Date",
      "value": "invoice_due_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "ship_location_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "product_description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO No",
      "value": "po_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Date",
      "value": "po_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "IRN No",
      "value": "irn_cs_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "IRN Date",
      "value": "irn_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GRN No",
      "value": "grn_cs_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GRN Date",
      "value": "grn_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "RCM Applicable",
      "value": "rcm_applicable",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GST Input Available",
      "value": "gst_not_applicable",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Scrap Material",
      "value": "scrap_gst_tds_invoice",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Account",
      "value": "account_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Balance PO QTY",
      "value": "balance_po_qty",
      "is_text": false, "is_number": true,
      "is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO QTY",
      "value": "total_required_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false,       "display": "Invoice QTY",
      "value": "invoice_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Accepted QTY",
      "value": "accepted_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Accepted Free Qty",
      "value": "free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Rejected QTY",
      "value": "rejected_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Conversion Unit Price",
      "value": "conversion_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Unit Price",
      "value": "po_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "FC Invoice Unit Price",
      "value": "conversion_invoice_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Unit Price",
      "value": "invoice_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unplanned Cost",
      "value": "unplanned_cost",
      "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'checkbox'
    },
    // {
    //   "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price Per Unit",
    //   "value": "invoice_total_price",
    //   "is_text": false, "is_number": true,
    //   "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    // },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "FC Paid Price Per Unit",
      "value": "conversion_paid_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Paid Price Per Unit",
      "value": "paid_unit_price",
      "icon": "",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price",
      "value": "invoice_total_price",
      "icon": "",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Paid Price",
      "value": "paid_total_price",
      "icon": "",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Difference Price Per Unit",
      "value": "difference_unit_price",
      "icon": "",
      "type": 'radio',
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Difference",
      "value": "difference_total_price",
      "icon": "",
      "type": 'radio',
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, 
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Period",
      "value": "to_from_loc_period",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Miscellaneous",
      "value": "miscellaneous",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Shipping Bill / Bill of Export No",
      "value": "shipping_bill_of_export_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Project",
      "value": "project_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Task",
      "value": "task_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "Paid CGST",
      "value": "paid_cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "Paid SGST",
      "value": "paid_sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "Paid IGST",
      "value": "paid_igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "Paid UGST",
      "value": "paid_ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "Paid CESS",
      "value": "paid_cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Paid Other Tax",
      "value": "paid_other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "Invoice CGST",
      "value": "invoice_cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "Invoice SGST",
      "value": "invoice_sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "Invoice IGST",
      "value": "invoice_igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "Invoice UGST",
      "value": "invoice_ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "Invoice CESS",
      "value": "invoice_cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Invoice Other Tax",
      "value": "invoice_other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Section",
      "value": "tds_section_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Rate",
      "value": "tds_rate",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Paid Price GST",
      "value": "paid_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price GST",
      "value": "invoice_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'po_hsn_cgst', "is_event": false, "display": "PO CGST",
      "value": "po_cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'po_hsn_sgst', "is_event": false, "display": "PO SGST",
      "value": "po_sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'po_hsn_igst', "is_event": false, "display": "PO IGST",
      "value": "po_igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'po_hsn_ugst', "is_event": false, "display": "PO UGST",
      "value": "po_ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'po_hsn_cess', "is_event": false, "display": "PO CESS",
      "value": "po_cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'po_hsn_other_tax', "is_event": false, "display": "PO Other Tax",
      "value": "po_other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Price",
      "value": "paid_grand_total",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Balance Budget Amount",
      "value": "budget_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Delivery Cost Center",
      "value": "delivery_cc_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amortization Type",
      "value": "amortization_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amortization Start Date",
      "value": "amortization_start_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amortization End Date",
      "value": "amortization_end_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Field 4",
      "value": "field4",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Field 5",
      "value": "field5",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Field 6",
      "value": "field6",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Channel",
      "value": "channel_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Merge Barcode",
      "value": "merge_barcode",
      "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "grnreport", "name": 'GRN Details', "Desscription": 'GRN', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
    "value": "title",
    "is_text": true, "is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice",
    "value": "invoice_amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Paid",
    "value": "paid_amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Debit Note",
    "value": "difference_amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice",
    "value": "is_ddc_total_invoice_amount",
    "is_text": true, "is_number": true,
    "is_ddc": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Paid",
    "value": "is_ddc_total_paid_amount",
    "is_text": true, "is_number": true,
    "is_ddc": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Debit Note",
    "value": "is_ddc_total_amount_difference",
    "is_text": true, "is_number": true,
    "is_ddc": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
  },
  ],
  "extraGrandColumnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL.No.",
      "value": "sl_no",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO No",
      "value": "po_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Section",
      "value": "section_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Rate",
      "value": "vendor_tds_rate",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Gross Amount",
      "value": "total_gross_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": " Advance Adjusted Amount",
      "value": "advance_adjusted_amount",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Amount",
      "value": "tds_amount",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Previous Tds Amount",
      "value": "previous_tds_amount",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Deduction",
      "value": "tds_deduction",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance TDS Adjusted",
      "value": "advance_adjusted_tds_amount",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total TDS Amount",
      "value": "total_tds_amount",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  'extra_data_list':{'title':'','records':[]}
}
export const grnVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "product_description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Allocated Dimension",
      "value": "rack_dimension_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "event": {
        "url": '/Stn_document_master/ajax_generatebarcode_bygrn',
        "type": "click",
      },
      "is_event": true, "display": "Bar Code",
      "value": "barcode_file_url",
      "is_download": true,
      "icon": 'fa fa-barcode fa-2x',
      "is_text": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "event": {
        "url": '/Stn_document_master/ajax_generateqrcode_bygrn',
        "type": "click",
      },
      "is_event": true, "display": "QR Code",
      "value": "qrcode_file_url",
      "is_download": true,
      "icon": 'fa fa-qrcode fa-2x',
      "is_text": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO QTY",
      "value": "total_required_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Free Qty",
      "value": "free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Balance Free Qty",
      "value": "balance_to_be_delivered_free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Received Free Qty",
      "value": "current_delivery_free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Received QTY",
      "value": "received_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice QTY",
      "value": "invoice_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Project Name",
      "value": "project_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Task Name",
      "value": "task_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Unit Price",
      "value": "invoice_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Accepted QTY",
      "value": "accepted_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Usable QTY",
      "value": "damaged_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Rejected QTY",
      "value": "rejected_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Reason For Reject",
      "value": "rejected_reason",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total QTY Inwarded",
      "value": "total_inward_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Reason",
      "value": "damaged_remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Send Mail To Procurement",
      "value": "send_damage_mail",
      "icon": "",
      "type": 'radio',
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GRN Checked Type",
      "value": "grn_checked_type_name",
      "icon": "",
      "type": 'radio',
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'radio'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sample Size",
      "value": "sample_size",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Error Size",
      "value": "error_size",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Rejection %",
      "value": "rejection_percentage",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Acceptable Rejection %",
      "value": "acceptable_rejection_percentage",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Is Closed",
      "value": "is_closed",
      "icon": "",
      "type": 'radio',
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Owned Type",
      "value": "product_owned_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Allocated Rack",
      "value": "allocated_rack_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Delivery Cost Center",
      "value": "delivery_cc_name",
      "is_text": true, "is_number": false,
      "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text',
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Merge Barcode",
      "value": "merge_barcode",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Unit Price",
      "value": "po_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Unit Price",
      "value": "po_total_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "QC value at PO price",
      "value": "total_grn_value_po_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "grnreport", "name": 'GRN Details', "Desscription": 'GRN', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const irnVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "product_description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO QTY",
      "value": "total_required_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Free Qty",
      "value": "free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Balance Free Qty",
      "value": "balance_to_be_delivered_free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Received Free Qty",
      "value": "current_delivery_free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Received QTY",
      "value": "received_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice QTY",
      "value": "invoice_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Project Name",
      "value": "project_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Task Name",
      "value": "task_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Unit Price",
      "value": "invoice_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Package Damaged",
      "value": "is_damaged",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Accepted QTY",
      "value": "accepted_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Rejected QTY",
      "value": "rejected_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Reason For Reject",
      "value": "rejected_reason",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Delivery Cost Center",
      "value": "delivery_cc_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text',
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Merge Barcode",
      "value": "merge_barcode",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Unit Price",
      "value": "po_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Unit Price",
      "value": "po_total_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },


  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "irnreport", "name": 'IRN Details', "Desscription": 'IRN', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const poVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "New Product Added Date",
      "value": "revised_po_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },



    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amend Status",
      "value": "amend_po_status",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amend QTY",
      "value": "amend_po_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amend Date",
      "value": "amend_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amend By",
      "value": "amend_added_by",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "ship_to_location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Stock",
      "value": "current_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Average Monthly Consumption",
      "value": "average_daily_consumption",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Inventory In Hands(Month)",
      "value": "inventory_in_hand",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Lead Time",
      "value": "lead_time",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "No Of Months Requested For",
      "value": "procured_days",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Service Start Date",
      "value": "service_start_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Service End Date",
      "value": "service_end_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Previously Raised Qty",
      "value": "previously_raised_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Open PO QNTY",
      "value": "open_po_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Open GRN QNTY",
      "value": "open_grn_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO QTY",
      "value": "product_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Free Qty",
      "value": "free_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Pending QTY",
      "value": "pending_qty",
      "is_text": false, "is_number": true,
      "is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Revised QTY",
      "value": "revised_qty",
      "is_text": false, "is_number": true,
      "is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total QTY",
      "value": "total_quantity",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Duration",
      "value": "total_duration",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Previously Raised Unit Price",
      "value": "previously_raised_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price",
      "value": "conversion_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Project",
      "value": "project_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Task",
      "value": "task_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Is CVPPM",
      "value": "is_cvppm",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price(INR)",
      "value": "product_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discount %",
      "value": "discount_percentage",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discount Unit Price",
      "value": "discount_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discounted Unit Price",
      "value": "discounted_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total",
      "value": "total",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discount Total Price",
      "value": "discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discounted Total Price",
      "value": "discounted_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "CGST",
      "value": "cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "SGST",
      "value": "sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "IGST",
      "value": "igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "UGST",
      "value": "ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "CESS",
      "value": "cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Other Tax",
      "value": "other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Delivery Cost Center",
      "value": "delivery_cc_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Storage Location",
      "value": "storage_location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Channel",
      "value": "channel_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Required By",
      "value": "product_required_by",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HAZ",
      "value": "haz",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HS Code",
      "value": "hs_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "UN No",
      "value": "un_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Packaging Details",
      "value": "packaging_details",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sample Details",
      "value": "sample_details",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Grand Total",
      "value": "grand_total",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Budget Amount",
      "value": "budget_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Send To Logistic",
      "value": "is_logistic",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Savings Category",
      "value": "saving_category",
      "is_text": true, "is_number": false,
      "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Savings Amount in Base Currency",
      "value": "saving_amount_in_base_currency",
      "is_text": false, "is_number": true,
      "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "poreport", "name": 'PO Details', "Desscription": 'PO', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
      "value": "title",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
      "value": "amount",
      "is_text": true, "is_number": true,
"is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
      "value": "foreign_amount",
      "is_text": true, "is_number": true,
      "is_ddc": true, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'PO Annexure List','records':[
    {'value':'key_1','display':'', "is_view": true},
    {'value':'key_2','display':'', "is_view": true},
    {'value':'key_3','display':'', "is_view": true},
    {'value':'key_4','display':'', "is_view": true},
    {'value':'key_5','display':'', "is_view": true},
    {'value':'key_6','display':'', "is_view": true},
  ]}

}
export const mpVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PR NO",
      "value": "pr_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Re Order level",
      "value": "re_order_level",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "MOQ",
      "value": "moq",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Actual Stock",
      "value": "actual_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Approved PR QTY",
      "value": "approved_pr_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Already Ordered QTY",
      "value": "already_ordered_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Planned QTY",
      "value": "planned_order_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Average Daily Consumption",
      "value": "average_daily_consumption",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Seasonal Growth rate %",
      "value": "seasonal_growth",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Growth Rate %",
      "value": "growth",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "mpreport", "name": 'Mp Details', "Desscription": 'Mp', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const siVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PR NO",
      "value": "pr_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    , {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Project",
      "value": "project_detail",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }
    , {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Customer",
      "value": "customer_detail",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Catalog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Quantity Required",
      "value": "quantity_required",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Quantity Available",
      "value": "quantity_available",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Previous Issue Quantity",
      "value": "previous_issue_quantity",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Issue Quantity",
      "value": "issue_quantity",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Unit Price",
      "value": "product_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Issue To Employee",
      "value": "issued_to",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Issue To Type",
      "value": "issued_to_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "mpreport", "name": 'Mp Details', "Desscription": 'Mp', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const prVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "product_description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Make",
      "value": "make",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Model",
      "value": "model",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Additional Field 1",
      "value": "additional_field1",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Additional Field 2",
      "value": "additional_field2",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Catalog ID",
      "value": "product_catalog_id", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Previous Quantity",
      "value": "already_raised_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Is Item Closed",
      "value": "is_closed_item_wise",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price",
      "value": "ddc_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price",
      "value": "unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product No",
      "value": "pr_product_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },{
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product L",
      "value": "pr_product_l",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },{
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product B",
      "value": "pr_product_b",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },{
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product D",
      "value": "pr_product_d",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Project",
      "value": "project_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Task",
      "value": "task_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PR Quantity",
      "value": "product_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Value",
      "value": "total_value",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Stock",
      "value": "current_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Shortfall Quantity",
      "value": "shortfall_quantity",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Average daily Consumption",
      "value": "average_daily_consumption",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Inventory In hand",
      "value": "inventory_in_hand",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Lead Time",
      "value": "lead_time",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "MOQ",
      "value": "moq",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Procured Days",
      "value": "procured_days",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Required By",
      "value": "product_required_by",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Delivery Cost Center",
      "value": "delivery_cc_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Preferred Vendor",
      "value": "ven_list",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'list'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "prreport", "name": 'PR Details', "Desscription": 'PR', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:true
  }
]
,
  "grandColumnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
      "value": "title",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Value",
      "value": "amount",
      "is_text": true, "is_number": true,
"is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Value",
      "value": "foreign_amount",
      "is_text": true, "is_number": true,
      "is_ddc": true, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const irVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "IR No",
      "value": "ir_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Requested To Cost Centre",
      "value": "location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Catalog ID",
      "value": "product_catalog_id", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Quantity",
      "value": "product_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price",
      "value": "unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Value",
      "value": "total_value",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Stock",
      "value": "current_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Average daily Consumption",
      "value": "average_daily_consumption",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Inventory In hand",
      "value": "inventory_in_hand",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Lead Time",
      "value": "lead_time",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "MOQ",
      "value": "moq",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Procured Days",
      "value": "procured_days",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Required By",
      "value": "product_required_by",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "irreport", "name": 'IR Details', "Desscription": 'IR', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Title",
      "value": "title",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Value",
      "value": "amount",
      "is_text": true, "is_number": true,
      "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Value",
      "value": "foreign_amount",
      "is_text": true, "is_number": true,
      "is_ddc": true, "is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const irHistoryVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Catalog ID",
      "value": "product_catalog_id", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Type",
      "value": "product_type", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PR Quantity",
      "value": "product_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price",
      "value": "unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Value",
      "value": "total_value",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Stock",
      "value": "current_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Average daily Consumption",
      "value": "average_daily_consumption",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Inventory In hand",
      "value": "inventory_in_hand",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Lead Time",
      "value": "lead_time",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "MOQ",
      "value": "moq",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Procured Days",
      "value": "procured_days",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_view": false,
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Required By",
      "value": "product_required_by",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "ir_history_report", "name": 'IR Details', "Desscription": 'IR', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  'extra_data_list':{'title':'','records':[]}

}
export const mprVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SKU",
      "value": "productcode",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Catalog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Pending Qty",
      "value": "pending_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Available Qty",
      "value": "available_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Already Requested Qty",
      "value": "already_request_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Suggested Qty",
      "value": "suggested_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Requested Qty",
      "value": "to_be_requested_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Buffer Stock",
      "value": "buffer_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Department Requested From",
      "value": "requested_department",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Is This My BOQ",
      "value": "is_this_my_boq",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "prreport", "name": 'PR Details', "Desscription": 'PR', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  'extra_data_list':{'title':'','records':[]}

}
export const stnVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SKU",
      "value": "sku",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Price",
      "value": "product_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Available Stock",
      "value": "available_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Quantity To Be Transfer",
      "value": "qty_to_be_transfer",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Closing Stock",
      "value": "closing_stock",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "stnreport", "name": 'stn Details', "Desscription": 'stn', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const proformainvoiceVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Account",
      "value": "account_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice QTY",
      "value": "invoice_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Price Per Unit",
      "value": "product_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "Invoice CGST",
      "value": "invoice_cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "Invoice SGST",
      "value": "invoice_sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "Invoice IGST",
      "value": "invoice_igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "Invoice UGST",
      "value": "invoice_ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "Invoice CESS",
      "value": "invoice_cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Invoice Other Tax",
      "value": "invoice_other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price GST",
      "value": "invoice_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice Price",
      "value": "invoice_total_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "proformainvoicereport", "name": 'Proforma Invoice Details', "Desscription": 'Proforma Invoice', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
    "value": "title",
    "is_text": true, "is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice",
    "value": "invoice_amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
//sales Order
export const SalesOrderVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL.NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    // {
    //   "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Product CataLog ID",
    //   "value": "product_catalog_id",
    //   "is_text": true,"is_number": false,
    //   "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":false,"input_type":'text'
    // },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Category",
      "value": "category_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "HSN Code",
      "value": "hsn_code",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Account Name",
      "value": "account_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    // {
    //   "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Ship Location",
    //   "value": "location",
    //   "is_text": true,"is_number": false,
    //   "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    // },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Stock Qty",
      "value": "stock_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sales QTY",
      "value": "invoice_qty",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Price Per Unit",
      "value": "product_unit_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Amount",
      "value": "total_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discount",
      "value": "discount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Discount Amount",
      "value": "discount_value_sale",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Required By Date",
      "value": "required_by_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "Sales CGST",
      "value": "invoice_cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "Sales SGST",
      "value": "invoice_sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "Sales IGST",
      "value": "invoice_igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "Sales UGST",
      "value": "invoice_ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "Sales CESS",
      "value": "invoice_cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Sales Other Tax",
      "value": "invoice_other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Sales Price GST",
      "value": "invoice_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Sales Price",
      "value": "invoice_total_price",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "salesOrderData", "name": 'Sales Details', "Desscription": 'Sales Order', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
    "value": "title",
    "is_text": true, "is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Sales",
    "value": "invoice_amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const salesinvoiceVariableList: any = {
  "columnList": [
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "SL. NO.",
      "value": "sl_no",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Product Name",
      "value": "product_name",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Product CataLog ID",
      "value": "product_catalog_id",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":false,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Category",
      "value": "category_name",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Sub-Category",
      "value": "subcategory_name",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "HSN Code",
      "value": "hsn_code",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Account",
      "value": "account_name",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Ship Location",
      "value": "location",
      "is_text": true,"is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":false,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Stock In Hand",
      "value": "available_stock",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Invoice QNTY",
      "value": "invoice_qty",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },

    {
      "is_currency":true,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Purchase PO Price",
      "value": "inventory_unit_price",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Conversion Unit Price",
      "value": "conversion_unit_price",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":false,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Price Per Unit",
      "value": "product_unit_price",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },{
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":true,"extra_is_number":false,"extra_value":'hsn_cgst',"is_event":false,"display": "CGST",
      "value": "invoice_cgst",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":true,"extra_is_number":false,"extra_value":'hsn_sgst',"is_event":false,"display": "SGST",
      "value": "invoice_sgst",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":true,"extra_is_number":false,"extra_value":'hsn_igst',"is_event":false,"display": "IGST",
      "value": "invoice_igst",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":true,"extra_is_number":false,"extra_value":'hsn_ugst',"is_event":false,"display": "UGST",
      "value": "invoice_ugst",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":true,"extra_is_number":false,"extra_value":'hsn_cess',"is_event":false,"display": "CESS",
      "value": "invoice_cess",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":true,"extra_is_number":false,"extra_value":'hsn_other_tax',"is_event":false,"display": "Other Tax",
      "value": "invoice_other_tax",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },

    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Total GST",
      "value": "invoice_tax",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
    {
      "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Total Price excluding GST",
      "value": "invoice_total_price",
      "is_text": false,"is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "salesinvoicereport", "name": 'Sales Invoice Details', "Desscription": 'Sales Invoice', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "-",
    "value": "title",
    "is_text": true,"is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
  },
  {
    "is_currency":false,"event":{},'is_attachment':false,"is_extra":false,"extra_is_number":false,"extra_value":'',"is_event":false,"display": "Invoice",
    "value": "invoice_amount",
    "is_text": true,"is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled":true,"is_view":true,"input_type":'text'
  },
  ],
  "extraGrandColumnList": [  ]
}
export const invoicePaymentVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {type:'modal_show',id:'dcnotereport',is_array_data:'1'}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": true, "display": "Debit No",
      "value": "dc_list",
      "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Debit Amount",
      "value": "debit_note_amount",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice No",
      "value": "invoice_cs_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor",
      "value": "vendor_address",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice",
      "value": "total_invoice_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Retention Amount",
      "value": "total_balance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Cash Discount",
      "value": "cash_discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Volume Discount",
      "value": "volume_discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GST Deduction",
      "value": "gst_deduction_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Payable",
      "value": "total_payable_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Other Payment Deduction",
      "value": "other_payment_deduction",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Payable",
      "value": "current_payable_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Payment Adjustment for DC/Advance",
      "value": "payment_adjustment_dc_advance",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Adjustment Ref ID",
      "value": "adjustment_ref_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Balance Current Payment",
      "value": "balance_current_payment",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Attachments",
      "value": "attachments", "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Bank Pay Status",
      "value": "bank_pay_status", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Bank Pay Status Remarks",
      "value": "bank_pay_status_rem", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "invoicepaymentreport", "name": 'Invoice Payment Details', "Desscription": 'Invoice Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const poPaymentVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO No",
      "value": "po_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor",
      "value": "vendor",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance Payment",
      "value": "advance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Balance Amount",
      "value": "balance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Paid Amount",
      "value": "paid_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Paid Amount %",
      "value": "paid_amount_percentage",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Bank Name",
      "value": "bank_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Payment Date",
      "value": "payment_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "popaymentreport", "name": 'po Payment Details', "Desscription": 'po Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}

export const invoiceRetentionPaymentVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice No",
      "value": "invoice_cs_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor",
      "value": "vendor",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice",
      "value": "total_invoice_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Retention Amount",
      "value": "total_balance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Cash Discount",
      "value": "cash_discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Volume Discount",
      "value": "volume_discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GST Deduction",
      "value": "gst_deduction_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Payable",
      "value": "total_payable_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Payable",
      "value": "current_payable_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "invoiceretentionpaymentreport", "name": 'Invoice Payment Details', "Desscription": 'Invoice Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const invoicePartPaymentVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {type:'modal_show',id:'dcnotereport',is_array_data:'1'}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": true, "display": "Debit No",
      "value": "dc_list",
      "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Debit Amount",
      "value": "debit_note_amount",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice No",
      "value": "invoice_cs_id",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor",
      "value": "vendor",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Invoice",
      "value": "total_invoice_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Retention Amount",
      "value": "total_balance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    }, {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Cash Discount",
      "value": "cash_discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Volume Discount",
      "value": "volume_discount_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Payable",
      "value": "total_payable_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GST Deduction",
      "value": "gst_deduction_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Paid",
      "value": "current_paid_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Payable",
      "value": "current_payable_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },{
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Bank Pay Status",
      "value": "bank_pay_status", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Bank Pay Status Remarks",
      "value": "bank_pay_status_rem", "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "invoicepartpaymentreport", "name": 'Invoice Payment Details', "Desscription": 'Invoice Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const myAdvancePaymentVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance Type",
      "value": "advance_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "From Date",
      "value": "from_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "To Date",
      "value": "to_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance Amount",
      "value": "advance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Is Re-imburshable",
      "value": "is_reimburshable",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Attachment",
      "value": "attachment",
      "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "my_advance_report", "name": 'My Advance Payment Details', "Desscription": 'po Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const employeeAdvancePaymentVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance Type",
      "value": "advance_type",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "From Date",
      "value": "from_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "To Date",
      "value": "to_date",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance Amount",
      "value": "advance_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Payble Amount",
      "value": "payble_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Retention Amount",
      "value": "retention_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Bank",
      "value": "bank_details",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Payment Date",
      "value": "date_of_payment",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Is Re-imburshable",
      "value": "is_reimburshable",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Attachment",
      "value": "attachment",
      "is_text": false, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "employee_advance_payment_report", "name": 'Employee Advance Payment Details', "Desscription": 'po Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}

export const invoice_andoird_VariableList: any = {
  "columnList": [],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "invoice_android_report", "name": 'Invoice Details', "Desscription": 'Invoice', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}

export const dcNoteVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Description",
      "value": "description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "GST in D/C Note",
      "value": "gst_checked",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'checkbox'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
      "value": "ddc_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view":false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
      "value": "amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
   
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "CGST",
      "value": "cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "SGST",
      "value": "sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "IGST",
      "value": "igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "UGST",
      "value": "ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "CESS",
      "value": "cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Other Tax",
      "value": "other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total GST",
      "value": "total_gst",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Amount",
      "value": "total_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "dcnotereport", "name": 'D/C Details', "Desscription": 'PO', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
    "value": "title",
    "is_text": true, "is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
    "value": "amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  }
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const creditNoteVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Description",
      "value":"description",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
      "value": "amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cgst', "is_event": false, "display": "CGST",
      "value": "cgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
    ,
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_sgst', "is_event": false, "display": "SGST",
      "value": "sgst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_igst', "is_event": false, "display": "IGST",
      "value": "igst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_ugst', "is_event": false, "display": "UGST",
      "value": "ugst",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_cess', "is_event": false, "display": "CESS",
      "value": "cess",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": true, "extra_is_number": false, "extra_value": 'hsn_other_tax', "is_event": false, "display": "Other Tax",
      "value": "other_tax",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total GST",
      "value": "total_gst",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Total Amount",
      "value": "total_amount",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "dcnotereport", "name": 'Credit Note Details', "Desscription": 'PO', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [{
    "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "-",
    "value": "title",
    "is_text": true, "is_number": false,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  },
  {
    "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Amount",
    "value": "amount",
    "is_text": true, "is_number": true,
    "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
  }
  ],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}

export const logisticsVariableList: any = {
  "columnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO No",
      "value": "po_no",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Ship Location",
      "value": "location",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product/Service Name",
      "value": "product",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "QTY",
      "value": "quantity",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Partner",
      "value": "logistic_partner",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Required By",
      "value": "product_required_by",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Expected Delivery Date",
      "value": "delivery_date",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Actual Dispatch Date",
      "value": "actual_dispatch_date",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Tracking ID",
      "value": "tracking_id",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Delivery Status",
      "value": "delivery_status",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor Person Contact Name",
      "value": "vendor_contact_person_name",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor Person Contact Email",
      "value": "vendor_contact_person_email",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor Person Contact No",
      "value": "vendor_contact_person_contact_no",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Contact Email",
      "value": "contact_email",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Contact Mobile",
      "value": "contact_mobile",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Nos Of Package",
      "value": "nos_of_package",
       "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "my_advance_report", "name": 'My Advance Payment Details', "Desscription": 'po Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':{'title':'','records':[]}

}
export const adhocpaymentVariableList: any = {
  "columnList":[],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "adhocpaymentreport", "name": 'Adhoc Advance Payment Details', "Desscription": 'Adhoc Advance Payment', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view",
is_visible:false
  },
{
    "name": "Required Info",
    "icon": "fa fa-eye",
    "action": "Enquery_showIssue",
is_visible:false
  }
]
,
  "grandColumnList": [],
  "extraGrandColumnList": [
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL.No.",
      "value": "sl_no",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Section Name",
      "value": "section_name",
      "is_text": true, "is_number": false,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Rate",
      "value": "tds_rate",
      "is_text": false, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Amount",
      "value": "po_amount",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Advance Amount",
      "value": "advance_amount",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "TDS Deduction",
      "value": "tds_deduction",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html":false,"is_currency": true, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Net Payment",
      "value": "net_payment",
      "is_text": true, "is_number": true,
      "is_ddc": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  'extra_data_list':{'title':'','records':[]}
}

export const rfqVariableList: any = {
  "columnList": [
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no",
      "is_text": true, "is_number": false,
      "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PR No",
      "value": "pr_no","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Catalog ID",
      "value": "product_catalog_id","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Description",
      "value": "description","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Make",
      "value": "make","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Model",
      "value": "model","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Additional Field1",
      "value": "additional_field1","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Additional Field2",
      "value": "additional_field2","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "UOM",
      "value": "uom_name","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product No",
      "value": "boq_product_nos","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product L",
      "value": "boq_product_l","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product B",
      "value": "boq_product_b","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product D",
      "value": "boq_product_d","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Quantity",
      "value": "qty","is_text": false, "is_number": true,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    
    {
      "is_currency": true,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Target Price",
      "value": "target_price", "is_text": false, "is_number": true,
      "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text', 'currency': '',
    },
    {
      "is_currency": true,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Minimum Decrease in Bid Amount",
      "value": "min_bid_revised_amount","is_text": false, "is_number": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text', 'currency': '',
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "PO Past Value",
      "value": "po_price_list","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'list'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Selected Vendor Name",
      "value": "selected_vendor_name","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text'
    },
    {
      "is_currency": true,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Selected Vendor Unit Price",
      "value": "selected_vendor_unit_price","is_text": false, "is_number": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text', 'currency': '',
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Selected Vendor GST Price",
      "value": "selected_vendor_gst_amount","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text', 'currency': '',
    },
    {
      "is_currency": true,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Selected Vendor Total Price",
      "value": "selected_vendor_price","is_text": false, "is_number": true,"is_download": false, "is_disabled": true, "is_view": false, "input_type": 'text', 'currency': '',
    },

    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Required By",
      "value": "required_by_date","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    
    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Vendor Remarks",
      "value": "vendor_remarks","is_text": true, "is_number": false,"is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },

    {
      "is_currency": false,"is_html":false, "event": {}, 'is_attachment': true, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Attachment",
      "value": "company_item_attachments", "is_text": false, "is_number": false,
      "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
  ],
  "afterDivList": [],
  "beforeDivList": [],
  "modalDetails": { "id": "rfqNumberReport", "name": 'RFQ Details', "Desscription": 'RFQ', "is_view": true },
  "actionsList": [{
    "name": "View",
    "icon": "fa fa-eye",
    "action": "view"
  }],
  "grandColumnList": [],
  "extraGrandColumnList": [],
  'extra_data_list':
  {
    'title':'',
    'records':[],
  }
}

export const gatePassVariableList: any = {
  "columnList": [
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "SL. NO.",
      "value": "sl_no", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Name",
      "value": "product_name", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Product Description",
      "value": "product_description", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Unit Type",
      "value": "unit_type_name", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Current Received Qty",
      "value": "current_received_qty", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Qty",
      "value": "invoice_qty", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Invoice Price",
      "value": "invoice_price", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    },
    {
      "is_html": false, "is_currency": false, "event": {}, "is_attachment": false, "is_extra": false, "extra_is_number": false, "extra_value": '', "is_event": false, "display": "Remarks",
      "value": "remarks", "is_text": true, "is_number": false, "is_ddc": false, "is_download": false, "is_disabled": true, "is_view": true, "input_type": 'text'
    }
  ],
  "grandColumnList": [],
  "extraGrandColumnList": []
}



// WEBPACK FOOTER //
// /codebuild/output/src2122162221/src/src/app/commonVariableList/addInvoice.ts